import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import store from "./store";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";

import InterceptorsComponent from "./NestedComponents/interceptorsComponent";
import QuestionsPage from "./NestedComponents/innerDealPanel/questionsPage";
import Login from "./RouteComponents/userComponents/login";
import Register from "./RouteComponents/userComponents/register";
import ForgetPassword from "./RouteComponents/userComponents/forgotPass";
import TokenConf from "./RouteComponents/userComponents/conf-token";
import BtaxAdapter from "./RouteComponents/btaxAdapter";
import MessagePage from "./RouteComponents/userComponents/messagePage";
import SetNewPass from "./RouteComponents/userComponents/setNewPass";
import NotificationsCenter from "./NestedComponents/widgets/notificationsCenter";
import LogoutBtn from "./NestedComponents/widgets/logout";
import VideoWatchingPlatform from "./RouteComponents/VideoWatchingPlatform";

// Admin
import AdminContainer from "./RouteComponents/adminComponents/adminContainer";

import AdminGuard from "./auth/adminGuard";
import OnlyNotLoggedInRoute from "./auth/onlyNotLoggedInGuard";

import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "react-calendar/dist/Calendar.css";

class App extends Component {
  render() {
    return (
      <React.Fragment>
        <Provider store={store}>
          <BrowserRouter>
            <InterceptorsComponent />
            <ToastContainer rtl limit={6} pauseOnFocusLoss={false} />

            <div className="App">
              <div className="container custom-con mt-50">
                <Switch>
                  {/* Btax Adapter */}
                  <Route path="/btax-adapter" component={BtaxAdapter} />
                  <Route path="/message/:messageType?" component={MessagePage} />
                  {/* guests */}
                  <OnlyNotLoggedInRoute exact path="/" component={Login} />
                  <OnlyNotLoggedInRoute path="/login" component={Login} />
                  <OnlyNotLoggedInRoute exact path="/register" component={Register} />
                  <OnlyNotLoggedInRoute exact path="/forgot-password" component={ForgetPassword} />
                  <OnlyNotLoggedInRoute exact path="/set-new-pass/:token/:clientEmail" component={SetNewPass} />
                  <OnlyNotLoggedInRoute path="/conf-token/:token/:confType/:clientEmail" component={TokenConf} />
                  <Route path="/client-fills/:dealId?/:clientEmail?" component={QuestionsPage} />
                  {/* logged in users */}
                  {/* Admin */}
                  <AdminGuard path="/admin" component={AdminContainer} />

                  <Route path="/video-watching/:episodeId?" component={VideoWatchingPlatform} />

                  {/* Catch other routes */}
                  <OnlyNotLoggedInRoute path="*" component={Login} />
                </Switch>
              </div>
            </div>
            <LogoutBtn />
            <NotificationsCenter />
          </BrowserRouter>
        </Provider>
      </React.Fragment>
    );
  }
}

export default App;
